import { AloAccompagnement } from "./AloAccompagnement"
import { AloAllergene } from "./AloAllergene"
import { AloBase, getDefaultAloBase } from "./AloBase"
import { AloPlatLg, getDefaultAloPlatLg } from "./AloPlatLg"


export interface AloPlat extends AloBase  {    
    image?:string
    prix?:number|null
    template:string
    platsIds?:Array<number>
    allergenesIds?:Array<number>    
    biosIds?:Array<number>    
    descriptif?:string    
    prixAccompagnement?:number|null
    accompagnementsIds?:Array<number>   
    qtyAccompagnementGratuit?:number   
    parfums?:Array<string>
    iconId?:number|null
    arboId?:number|null
    qty?:number|null
    cuissons?:Array<string>
    tva?:number    
    lgs:Array<AloPlatLg>
}

export const getDefaultAloPlat = ():AloPlat => {
    return {
        ...getDefaultAloBase(),
        image:'',
        prix:null,
        template:'',
        platsIds:[],
        allergenesIds:[],
        biosIds:[],
        prixAccompagnement:null,
        accompagnementsIds:[],
        qtyAccompagnementGratuit:0,        
        descriptif:'',
        parfums:[],
        iconId:null,
        arboId:null,
        qty:null,
        cuissons:[],
        tva:1000,
        lgs:[getDefaultAloPlatLg()]
    }
}
